/* Immediate display from a complete, bounded Shopify snapshot; every selection
   is still reconciled against a fresh Section Rendering response. */
(() => {
  if (window.AndCharlieVariantSelection) return;
  window.AndCharlieVariantSelection = class {
    constructor(root) {
      this.root = root;
      this.refresh(root);
    }
    refresh(source) {
      this.entries = null;
      try {
        const catalog = JSON.parse(source.querySelector('[data-ac-variant-catalog]')?.textContent);
        if (String(catalog.productId) !== this.root.dataset.productId || catalog.count < 1 || catalog.count > 50 ||
            catalog.count !== catalog.entries.length || catalog.entries.some(({ variant }) =>
              !variant?.id || !Array.isArray(variant.options) || typeof variant.available !== 'boolean' ||
              variant.requires_selling_plan || variant.unit_price_measurement ||
              variant.quantity_rule?.min !== 1 || variant.quantity_rule?.increment !== 1 || variant.quantity_rule?.max != null)) return;
        this.entries = catalog.entries;
        this.prices = new Map(Array.from(source.querySelectorAll('[data-ac-variant-price]'), t => [t.dataset.acVariantPrice, t.innerHTML]));
        this.updatedAt = Date.now();
      } catch { /* Missing/unsupported data uses the authoritative server path. */ }
    }
    invalidate() { this.entries = null; }
    response(optionIds) {
      const root = this.root;
      // Inventory text, SKU blocks, B2B/volume prices, subscriptions and combined
      // listings must keep their native server rendering, without guesses.
      if (!this.entries || Date.now() - this.updatedAt > 300000 ||
          root.querySelector('.product__inventory, [id^="Sku-"], volume-pricing, [name="selling_plan"]')) return null;
      const picker = root.variantSelectors;
      if (!picker) return null;
      const groups = Array.from(picker.querySelectorAll('[data-ac-option-position]'))
        .sort((a, b) => Number(a.dataset.acOptionPosition) - Number(b.dataset.acOptionPosition));
      if (groups.length !== optionIds.length) return null;
      const inputs = groups.map((g, index) => Array.from(g.querySelectorAll('[data-option-value-id]'))
        .find(input => input.dataset.optionValueId === optionIds[index]));
      if (inputs.some(input => !input || (input.dataset.productUrl && input.dataset.productUrl !== root.dataset.url))) return null;
      const values = inputs.map(input => input.value);
      const entry = this.entries.find(({ variant }) => variant.options.length === values.length && variant.options.every((value, i) => value === values[i]));
      if (entry && !this.prices.has(entry.priceKey)) return null;

      const doc = document.implementation.createHTMLDocument('');
      const source = doc.createElement('product-info');
      doc.body.append(source);
      const nextPicker = picker.cloneNode(true);
      source.append(nextPicker);
      nextPicker.querySelector('[data-selected-variant]').textContent = JSON.stringify(entry?.variant || null);
      if (entry) nextPicker.dataset.selectedPriceAmount = entry.amount;
      for (const group of nextPicker.querySelectorAll('[data-ac-option-position]')) {
        const index = Number(group.dataset.acOptionPosition) - 1;
        for (const input of group.querySelectorAll('[data-option-value-id]')) {
          const chosen = input.dataset.optionValueId === optionIds[index];
          if (input.tagName === 'OPTION') { input.selected = chosen; input.toggleAttribute('selected', chosen); }
          else { input.checked = chosen; input.toggleAttribute('checked', chosen); }
          const isSize = group.hasAttribute('data-ac-size-option');
          const candidates = this.entries.filter(({ variant }) => variant.options[index] === input.value &&
            (!isSize || variant.options.every((value, i) => i === index || value === values[i])));
          const available = candidates.some(({ variant }) => variant.available);
          input.classList.toggle('disabled', !available && !input.classList.contains('swatch-input__input'));
          input.classList.toggle('visually-disabled', !available && input.classList.contains('swatch-input__input'));
          const missing = isSize && candidates.length === 0;
          input.dataset.acCombination = missing ? 'missing' : available ? 'available' : 'soldout';
          if (input.tagName === 'OPTION') input.textContent = missing ? `${input.value}（取扱いなし）` : available ? input.value : `${input.value}（売り切れ）`;
        }
        const selectedLabel = group.querySelector('[data-selected-value]:not(.dropdown-swatch)');
        if (selectedLabel) selectedLabel.textContent = values[index];
      }
      if (!entry) return doc;
      const price = doc.createElement('div');
      price.id = `price-${root.sectionId}`;
      price.innerHTML = this.prices.get(entry.priceKey);
      source.append(price);
      const button = doc.createElement('button');
      button.id = `ProductSubmitButton-${root.sectionId}`;
      button.disabled = !entry.variant.available;
      source.append(button);
      const quantity = root.querySelector('.product-form__quantity')?.cloneNode(true);
      if (quantity) {
        quantity.id = `Quantity-Form-${root.sectionId}`;
        const input = quantity.querySelector('.quantity__input');
        input.dataset.cartQuantity = entry.cartQuantity;
        input.dataset.min = '1';
        input.step = '1';
        input.removeAttribute('data-max');
        const cartCount = quantity.querySelector('.quantity__rules-cart');
        if (cartCount) {
          cartCount.classList.toggle('hidden', !entry.cartQuantity);
          const count = cartCount.querySelector('span');
          // Native Shopify translation includes the quantity-cart span.
          if (count) count.innerHTML = entry.cartCount;
        }
        const label = quantity.querySelector('[id^="quantity-label-"]');
        if (label) label.textContent = entry.cartLabel;
        source.append(quantity);
      }
      return doc;
    }
  };
})();
